import { FC } from "react";

type TPillSelectorProps = {
  extraWrapperClass?: string;
  extraItemClass?: string;
  pills: string[];
  selectedPill: string;
  setSelectedPill: (pill: string) => void;
};

const PillSelector: FC<TPillSelectorProps> = ({
  extraWrapperClass = "",
  extraItemClass = "",
  pills,
  selectedPill,
  setSelectedPill,
}) => {
  return (
    <div
      className={`peer pill-selector bg-gray-200 rounded-lg p-1 flex gap-1 shrink-0 ${extraWrapperClass}`}
    >
      {pills.map((pill) => (
        <button
          key={pill}
          type="button"
          className={`pill rounded-md px-3 font-semibold text-sm leading-tight h-8 ${selectedPill === pill ? "bg-white shadow-sm" : "hover:bg-white/50"} ${extraItemClass}`}
          onClick={() => setSelectedPill(pill)}
        >
          {pill}
        </button>
      ))}
    </div>
  );
};
export default PillSelector;
